/* https://dplatz.de/blog/2019/es6-bare-imports.html */
import Glide from '@glidejs/glide';

import { siblings } from '@glidejs/glide';

const initSlider = (glideContainer) => {

	console.log("Initializing slider on container", glideContainer);

	/** Returns an array of all siblings of the given element.
	*/
	let getAllSiblings = function(e) {
		let siblings = []; 

		if (!e.parentNode) {
			return siblings;
		}

		// iterate and collect siblings
		let sibling = e.parentNode.firstChild;
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== e) {
				siblings.push(sibling);
			}
			sibling = sibling.nextSibling;
		}

		return siblings;
	};

	var glide = new Glide(glideContainer, {
		type: 'carousel',
		perView: 3,
		startAt: 1,
		focusAt: 'center',
		autoplay: 20 * 1000,
		animationTimingFunc: 'ease-in-out',
		animationDuration: 500,
		gap: 0,
		swipeThreshold: 10,
		dragThreshold: false
	}).mount({

		/* https://github.com/glidejs/glide/issues/401 */
		CustomActiveClass: (Glide, Components, Events) => {
			var Component = {
				mount() {
					this.changeActiveSlide();
				},
				changeActiveSlide() {
					const slide = Components.Html.slides[Glide.index];

					// Add active animation to next index
					slide.classList.add("glide_slide-is-active");

					// Remove from all existing indices
					getAllSiblings(slide).forEach((sibling) => {
						sibling.classList.remove("glide_slide-is-active");
					});

					const lastIndex = Components.Html.slides.length - 1;

					// Fix for infinite scroll when next card
					if (Glide.index == 0) {
						Components.Html.slides[
							lastIndex
						].nextElementSibling.classList.add(
							"glide_slide-is-active"
						);
					}

					// Fix for infinite scroll when prev card
					if (Glide.index == lastIndex) {
						Components.Html.slides[0].previousElementSibling.classList.add(
							"glide_slide-is-active"
						);
					}
				},
			};
			Events.on("run", () => {
				Component.changeActiveSlide();
			});
			return Component;
		},

		'MoveTowardsClicked': function(Glide, Components, Events) {
			var component = {
				onMountAfter: function() {
					function gotoSlide(clickedSlide) {
						const curSlide = Components.Html.slides[Glide.index];
						const allSlides = Array.prototype.slice.call(
							Components.Html.root.querySelector('.glide__slides').children
						);
						const clickedSlideIdx = allSlides.indexOf(clickedSlide);
						const curSlideIdx = allSlides.indexOf(curSlide);

						if (clickedSlideIdx !== curSlideIdx) {
							Glide.go(clickedSlideIdx > curSlideIdx ? '>' : '<');
						}
					}

					Array.prototype.forEach.call(Components.Html.slides, function(el, i) {
						el.addEventListener('click', function() { gotoSlide(this) });
					});

					Array.prototype.forEach.call(Components.Clones.items, function(el, i) {
						el.addEventListener('click', function() { gotoSlide(this) });
					});
				}
			};

			Events.on('mount.after', function () {
				component.onMountAfter();
			});

			// Remember that this is already initialized
			glideContainer.classList.add('initialized');

			return component;
		}
	});

	glide.on('move', function(data) {
		var idx = glide.index + 1;
		document.querySelectorAll('.bierschau-texts > div').forEach(function(el, idx) {
			if (idx === glide.index) {
				el.classList.add('active');
			} else {
				el.classList.remove('active');
			}
		});
	});

	var buttonPrev = document.querySelector('.bierschau-controls > button[data-role="prev"]');
	var buttonNext = document.querySelector('.bierschau-controls > button[data-role="next"]');

	buttonPrev.addEventListener('click', function() {
		glide.go('<');
	});
	buttonNext.addEventListener('click', function() {
		glide.go('>');
	});

	return glide;
};



// There is no clean and easy way to run some javascript after the
// Gutenberg block was rendered, so this is what I'm doing.
//
document.addEventListener('DOMContentLoaded', function() {
	var el = document.querySelector('.bierschau');
	if (el !== null) {
		// Viewing page, the simple case
		initSlider(el.querySelector('.glide'));

	} else {
		// We're in editor, the difficult/ugly case:
		// The div is inside an annoying iframe that has yet to appear.
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				var nodes = Array.prototype.slice.call(mutation.addedNodes);
				nodes.forEach(function(node) {
					if (node.tagName === 'IFRAME') {
						node.onload = () => {
							setTimeout(() => {
								var ell = node.contentWindow.document.body.querySelector('.bierschau');
								if (ell !== null) {
									initSlider(ell.querySelector('.glide'));
								}
							}, 1000);
						}
					}
				});
			});
		});
		observer.observe(document, {
			childList: true,
			subtree: true,
			attributes: false,
			characterData: false
		});
	}
});

